"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveStyle = function retrieveStyle(theme) {
  return {
    base: {
      color: _colors["default"].black,
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTLabel', 'base', 'fontSize']),
      fontWeight: 400,
      fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily']),
      transform: 'translateZ(0)'
    },
    xxxsmall: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'xxxsmall'])
    },
    xxsmall: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'xxsmall'])
    },
    xsmall: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'xsmall'])
    },
    small: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'small'])
    },
    medium: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'medium'])
    },
    large: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'large'])
    },
    xlarge: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'xlarge'])
    },
    xxlarge: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'xxlarge'])
    },
    xxxlarge: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'xxxlarge'])
    },
    title: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'title'])
    },
    largeTitle: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'largeTitle'])
    },
    extraLight: {
      fontWeight: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'extraLight'], 200)
    },
    light: {
      fontWeight: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'light'], 300)
    },
    semibold: {
      fontWeight: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'semiBold'], 500)
    },
    bold: {
      fontWeight: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'bold'], 600)
    },
    extrabold: {
      fontWeight: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'extraBold'], 700)
    },
    primary: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTLabel', 'primary', 'color'])
    },
    secondary: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTLabel', 'secondary', 'color'])
    },
    alternative: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTLabel', 'alternative', 'color'])
    },
    gray: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTLabel', 'gray', 'color'])
    },
    darkGray: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTLabel', 'darkGray', 'color'])
    },
    white: {
      color: _colors["default"].white
    },
    error: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTLabel', 'error', 'color'])
    },
    uppercase: {
      textTransform: 'uppercase'
    },
    lowercase: {
      textTransform: 'lowercase'
    }
  };
};

exports.retrieveStyle = retrieveStyle;